import { render, staticRenderFns } from "./ErrorCard.vue?vue&type=template&id=cb6e330c&scoped=true&"
import script from "./ErrorCard.vue?vue&type=script&lang=js&"
export * from "./ErrorCard.vue?vue&type=script&lang=js&"
import style0 from "./ErrorCard.vue?vue&type=style&index=0&id=cb6e330c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6e330c",
  null
  
)

export default component.exports